import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  SmsConfigDTO,
  SmsConfigCreateRequestDTO,
  SmsConfigUpdateRequestDTO,
  SmsConfigRequestDelete,
  SmsConfigReadByTenantIdDTO,
  SmsConfigReadAllPaginatedRequestDTO,
  SmsConfigReadByRequestDTO,
  SmsConfigList
} from './sms-config.interface';

import {
  SmsConfig_create,
  SmsConfig_update,
  SmsConfig_delete,
  SmsConfig_readById,
  SmsConfig_readAll,
  SmsConfig_readAllPaginated,
  SmsConfig_readByTenantId,
} from 'src/app/GlobalVariables';
import { PaginatedDTO } from 'src/app/Common/common.interface';

@Injectable({
  providedIn: 'root'
})
export class SmsConfigService {
  constructor() { }
  http = inject(HttpClient)

  // Create
  SmsConfig_create(data: SmsConfigCreateRequestDTO): Observable<SmsConfigDTO> {
    return this.http.post<SmsConfigDTO>(SmsConfig_create, data);
  }

  // Update
  SmsConfig_update(data: SmsConfigUpdateRequestDTO): Observable<SmsConfigDTO> {
    return this.http.post<SmsConfigDTO>(SmsConfig_update, data);
  }

  // Delete
  SmsConfig_delete(data: SmsConfigRequestDelete): Observable<void> {
    return this.http.post<void>(SmsConfig_delete, data);
  }

  // Read by Id
  SmsConfig_readById(data:SmsConfigReadByRequestDTO): Observable<SmsConfigDTO> {
    return this.http.post<SmsConfigDTO>(SmsConfig_readById,data);
  }

  // Read All
  SmsConfig_readAll(data: SmsConfigReadByRequestDTO): Observable<SmsConfigList> {
    return this.http.post<SmsConfigList>(SmsConfig_readAll, data);
  }

  // Read All Paginated
 SmsConfig_readAllPaginated(data: SmsConfigReadAllPaginatedRequestDTO): Observable<SmsConfigList> {
  return this.http.post<SmsConfigList>(SmsConfig_readAllPaginated, data
    
  );
}

  // Read By TenantId
  SmsConfig_readByTenantId(data: SmsConfigReadByTenantIdDTO): Observable<SmsConfigList> {
    return this.http.post<SmsConfigList>(SmsConfig_readByTenantId, data);
  }

}
